export const state = {
    troca: {},
    produtosTroca: [],
    trocaVenda: {},
    produtosTrocaVenda: [],
    modalTrocaVenda: false,
}

export default {}